export const NODE_TYPE_ORDER: string[] = [
  "Domain Controllers",
  "CA server",
  "ESVT",
  "ESV",
  "EST",
  "ESC",
  "ESF",
  "EAS",
  "HM",
  "ELCN HM",
  "EAPP",
  "ELCN EApp",
  "ACET",
  "ACE",
  "AM",
  "ELCN AM",
  "NIM",
  "ENIM",
  "ENB",
  "EHB",
  "EPLCG",
  "NG",
  "CLM",
  "SCE",
  "C300V5",
  "UOC",
  "CN100",
  "C300PM",
  "EHPMx",
  "EHPM",
  "TCMI",
  "Virtual TCMI",
  "ELMM",
  "Soft ELMM",
  "HPM",
  "Virtual EHPMx",
  "PM",
  "APM",
  "SM LM",
  "FIM4",
  "FIM8",
  "CN900",
  "CE RTU",
  "OneWireless WDM",
  "SM",
  "SMSC",
  "CEPLC",
];

export const getNodeTypeIndex = (nodeType: string): number => {
  if (!nodeType) return NODE_TYPE_ORDER.length;
  const normalized = nodeType.trim();
  if (!normalized) return NODE_TYPE_ORDER.length;

  const exactIndex = NODE_TYPE_ORDER.indexOf(normalized);
  if (exactIndex !== -1) return exactIndex;

  for (let i = 0; i < NODE_TYPE_ORDER.length; i++) {
    if (
      NODE_TYPE_ORDER[i] &&
      (normalized.startsWith(NODE_TYPE_ORDER[i]) ||
      normalized.includes(NODE_TYPE_ORDER[i]))
    ) {
      return i;
    }
  }

  return NODE_TYPE_ORDER.length;
};

